export var JobStopType;
(function (JobStopType) {
    JobStopType["PickUp"] = "PickUp";
    JobStopType["DropOff"] = "DropOff";
})(JobStopType || (JobStopType = {}));
//# sourceMappingURL=JobStopType.js.map